export default __webpack_public_path__ + "static/media/detail_image.5c536db1.svg";